export class AgreementChangeStatusDto {
    agreementId: number;
    newStateId: number;
}